const BASE_PATH = "app/admin/get-user-subscription-list/";

export const SET_USERS_SUBSCRIPTION = `${BASE_PATH}set-users-subscription`;
